import {
  EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN,
  EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN,
  EMPLOYEE_STAFF_ON_CHANGE_KEYWORD,
  EMPLOYEE_STAFF_ON_CLICK_EXPORT,
  EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF,
  EMPLOYEE_STAFF_ON_CLICK_ROW,
  EMPLOYEE_STAFF_LIST_STAFF_REQUEST,
  EMPLOYEE_STAFF_LIST_ROLES_REQUEST,
  EMPLOYEE_STAFF_PAGE_REQUEST,
  EMPLOYEE_STAFF_SET_EMPLOYEES,
  EMPLOYEE_STAFF_SET_SUBMITTING,
  EMPLOYEE_STAFF_SET_OUTLETS,
  EMPLOYEE_STAFF_SET_ROLES,
  EMPLOYEE_STAFF_LIST_OUTLET_REQUEST,
  EMPLOYEE_STAFF_ON_CLICK_CANCEL,
  EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL,
  EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET,
  EMPLOYEE_STAFF_ON_SUBMIT_FORM,
  EMPLOYEE_STAFF_RESEND_INVITATION,
  EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE,
  EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL,
  EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL,
  EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL,
  EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL,
  EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION,
  EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL,
  EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA,
  EMPLOYEE_STAFF_ON_CANCEL_RESEND,
  EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE,
  EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST,
  EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_SHOW_PURCHASE_STAFF_SLOT_MODAL,
  EMPLOYEE_STAFF_HIDE_PURCHASE_STAFF_SLOT_MODAL,
  EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_MODAL,
  EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_MODAL,
  EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_NO_SLOT_MODAL,
  EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_NO_SLOT_MODAL,
  EMPLOYEE_STAFF_ACTIVE_STAFF_LIST_REQUEST,
  EMPLOYEE_STAFF_ON_CHANGE_STATUS,
  EMPLOYEE_STAFF_ON_CLICK_ADD_STAFF_SLOT,
  EMPLOYEE_STAFF_GET_FEATURE_PRICE,
  EMPLOYEE_STAFF_SET_FEATURE_PRICE,
  EMPLOYEE_STAFF_VERIFY_ADD_STAFF_SLOT,
  EMPLOYEE_STAFF_SET_SLOT_DETAIL,
  EMPLOYEE_STAFF_SHOW_DEACTIVATE_STAFF_MODAL,
  EMPLOYEE_STAFF_HIDE_DEACTIVATE_STAFF_MODAL,
  EMPLOYEE_STAFF_ON_DEACTIVATE_STAFF,
  EMPLOYEE_STAFF_ASSIGN_EMPLOYEE_TO_SLOT,
  EMPLOYEE_STAFF_ON_CLICK_REACTIVATE_BUTTON,
  EMPLOYEE_STAFF_SET_AVAILABLE_SLOTS,
  EMPLOYEE_STAFF_SET_ASSIGNED_EMPLOYEE,
  EMPLOYEE_STAFF_ON_CLICK_PAY_TO_REACTIVATE,
  EMPLOYEE_STAFF_SET_PENDING_BILLING,
  EMPLOYEE_STAFF_STOP_RENEWAL_SLOT,
  EMPLOYEE_STAFF_SHOW_STOP_RENEWAL_MODAL,
  EMPLOYEE_STAFF_HIDE_STOP_RENEWAL_MODAL,
  EMPLOYEE_STAFF_ON_CLICK_LINK_STOP_RENEWAL,
  EMPLOYEE_STAFF_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  EMPLOYEE_STAFF_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  EMPLOYEE_STAFF_DEACTIVATE_SET_ERROR_MESSAGE,
} from './constants';

export function openRightColumn() {
  return { type: EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN, payload: {} };
}

export function closeRightColumn() {
  return { type: EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function onChangeKeyword(payload) {
  return { type: EMPLOYEE_STAFF_ON_CHANGE_KEYWORD, payload };
}

export function onClickInviteStaff({ slot }) {
  return { type: EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF, payload: { slot } };
}

export function onClickRow({ employee, status }) {
  return { type: EMPLOYEE_STAFF_ON_CLICK_ROW, payload: { employee, status } };
}

export function onClickCancel() {
  return { type: EMPLOYEE_STAFF_ON_CLICK_CANCEL, payload: {} };
}

export function onClickExport(payload) {
  return { type: EMPLOYEE_STAFF_ON_CLICK_EXPORT, payload };
}

export function onCancelDeleteEmployee() {
  return { type: EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE, payload: {} };
}

export function onConfirmDeleteEmployee({ employee, previousEmployees }) {
  return {
    type: EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE,
    payload: { employee, previousEmployees },
  };
}

export function onClickDeleteEmployee() {
  return { type: EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE, payload: {} };
}

export function listStaffRequest(payload) {
  return { type: EMPLOYEE_STAFF_LIST_STAFF_REQUEST, payload };
}

export function listOutletRequest() {
  return { type: EMPLOYEE_STAFF_LIST_OUTLET_REQUEST, payload: {} };
}

export function listRolesRequest() {
  return { type: EMPLOYEE_STAFF_LIST_ROLES_REQUEST, payload: {} };
}

export function listPermissionRequest({ userId }) {
  return { type: EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST, payload: { userId } };
}

export function pageRequest(payload) {
  return { type: EMPLOYEE_STAFF_PAGE_REQUEST, payload };
}

export function setEmployees({ employees }) {
  return { type: EMPLOYEE_STAFF_SET_EMPLOYEES, payload: { employees } };
}

export function setOutlets({ outlets }) {
  return { type: EMPLOYEE_STAFF_SET_OUTLETS, payload: { outlets } };
}

export function setCanAccessRole({ canAccessRole }) {
  return {
    type: EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE,
    payload: { canAccessRole },
  };
}

export function setSubmitting({ submitting }) {
  return { type: EMPLOYEE_STAFF_SET_SUBMITTING, payload: { submitting } };
}

export function setEmployeeDetail({ employee }) {
  return { type: EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL, payload: { employee } };
}

export function setRoles({ roles }) {
  return { type: EMPLOYEE_STAFF_SET_ROLES, payload: { roles } };
}

export function showAssignOutletModal() {
  return { type: EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL, payload: {} };
}

export function hideAssignOutletModal() {
  return { type: EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL, payload: {} };
}

export function showEmployeeDeleteModal() {
  return { type: EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL, payload: {} };
}

export function hideEmployeeDeleteModal() {
  return { type: EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL, payload: {} };
}

export function showResendCaptchaModal() {
  return { type: EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL, payload: {} };
}

export function hideResendCaptchaModal() {
  return { type: EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL, payload: {} };
}

export function onCancelAssignOutlet() {
  return { type: EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET, payload: {} };
}

export function onClickAssignOutlet() {
  return { type: EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET, payload: {} };
}

export function onClickResendInvitation({ email }) {
  return {
    type: EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION,
    payload: { email },
  };
}

export function setResendCaptchaEmail({ email }) {
  return { type: EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL, payload: { email } };
}

export function onCancelResend() {
  return { type: EMPLOYEE_STAFF_ON_CANCEL_RESEND, payload: {} };
}

export function onClickResendWithValidCaptcha({ email }) {
  return {
    type: EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA,
    payload: { email },
  };
}

/**
 * @param outlet
 * @return {{type, payload: {outlets: *}}}
 */
export function onConfirmAssignOutlet({ assignedOutletIds }) {
  return {
    type: EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET,
    payload: { assignedOutletIds },
  };
}

export function onSubmitForm({
  values,
  previousEmployees,
  outlets,
  role,
  slotDetail,
  image,
}) {
  return {
    type: EMPLOYEE_STAFF_ON_SUBMIT_FORM,
    payload: { values, previousEmployees, outlets, role, slotDetail, image },
  };
}

export function resendInvitation({ email }) {
  return { type: EMPLOYEE_STAFF_RESEND_INVITATION, payload: { email } };
}

export function showPinRequiredModal() {
  return { type: EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL, payload: {} };
}

export function setPinRequiredModal({ message }) {
  return { type: EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL, payload: { message } };
}

export function hidePinRequiredModal() {
  return { type: EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL, payload: {} };
}

export function showPurchaseStaffSlotModal() {
  return { type: EMPLOYEE_STAFF_SHOW_PURCHASE_STAFF_SLOT_MODAL };
}

export function hidePurchaseStaffSlotModal() {
  return { type: EMPLOYEE_STAFF_HIDE_PURCHASE_STAFF_SLOT_MODAL };
}

export function showReactivateStaffModal() {
  return { type: EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_MODAL };
}

export function hideReactivateStaffModal() {
  return { type: EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_MODAL };
}

export function showReactivateStaffNoSlotModal() {
  return { type: EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_NO_SLOT_MODAL };
}

export function hideReactivateStaffNoSlotModal() {
  return { type: EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_NO_SLOT_MODAL };
}

export function activeStaffListRequest(payload) {
  return { type: EMPLOYEE_STAFF_ACTIVE_STAFF_LIST_REQUEST, payload };
}

export function onChangeStatus(payload) {
  return { type: EMPLOYEE_STAFF_ON_CHANGE_STATUS, payload };
}

export function onClickAddStaffSlot() {
  return { type: EMPLOYEE_STAFF_ON_CLICK_ADD_STAFF_SLOT, payload: {} };
}

export function getStaffFeaturePrice() {
  return { type: EMPLOYEE_STAFF_GET_FEATURE_PRICE, payload: {} };
}

export function setStaffFeaturePrice(featurePrice) {
  return { type: EMPLOYEE_STAFF_SET_FEATURE_PRICE, payload: { featurePrice } };
}

export function verifyAddStaffSlot(billingData) {
  return {
    type: EMPLOYEE_STAFF_VERIFY_ADD_STAFF_SLOT,
    payload: { billingData },
  };
}

export function setSlotDetail(slotDetail) {
  return { type: EMPLOYEE_STAFF_SET_SLOT_DETAIL, payload: { slotDetail } };
}

export function hideDeactivateStaffModal() {
  return { type: EMPLOYEE_STAFF_HIDE_DEACTIVATE_STAFF_MODAL };
}

export function showDeactivateStaffModal() {
  return { type: EMPLOYEE_STAFF_SHOW_DEACTIVATE_STAFF_MODAL };
}

export function onDeactivateStaff({ slot, previousEmployees }) {
  return {
    type: EMPLOYEE_STAFF_ON_DEACTIVATE_STAFF,
    payload: { slot, previousEmployees },
  };
}

export function assignEmployeeToSlot({
  slot,
  employee,
  user,
  staffFormValues,
}) {
  return {
    type: EMPLOYEE_STAFF_ASSIGN_EMPLOYEE_TO_SLOT,
    payload: { slot, employee, user, staffFormValues },
  };
}

export function onClickBtnReactivate(
  employee,
  availableSlots,
  user,
  formValues
) {
  return {
    type: EMPLOYEE_STAFF_ON_CLICK_REACTIVATE_BUTTON,
    payload: { employee, availableSlots, user, formValues },
  };
}

export function setAvailableSlots(availableSlots) {
  return {
    type: EMPLOYEE_STAFF_SET_AVAILABLE_SLOTS,
    payload: { availableSlots },
  };
}

export function setAssignedEmployee(assignedEmployee) {
  return {
    type: EMPLOYEE_STAFF_SET_ASSIGNED_EMPLOYEE,
    payload: { assignedEmployee },
  };
}

export function onClickPayReactivate(billingData, staffFormValues) {
  return {
    type: EMPLOYEE_STAFF_ON_CLICK_PAY_TO_REACTIVATE,
    payload: { billingData, staffFormValues },
  };
}

export function setPendingBilling(billing) {
  return { type: EMPLOYEE_STAFF_SET_PENDING_BILLING, payload: { billing } };
}

export function stopRenewalSlot(slot, previousSlots) {
  return {
    type: EMPLOYEE_STAFF_STOP_RENEWAL_SLOT,
    payload: { slot, previousSlots },
  };
}

export function hideStopRenewalModal() {
  return { type: EMPLOYEE_STAFF_HIDE_STOP_RENEWAL_MODAL, payload: {} };
}

export function showStopRenewalModal() {
  return { type: EMPLOYEE_STAFF_SHOW_STOP_RENEWAL_MODAL, payload: {} };
}

export function onClickLinkStopRenewal() {
  return { type: EMPLOYEE_STAFF_ON_CLICK_LINK_STOP_RENEWAL, payload: {} };
}

export function showPaymentGatewayErrorModal() {
  return { type: EMPLOYEE_STAFF_SHOW_PAYMENT_GATEWAY_ERROR_MODAL, payload: {} };
}

export function hidePaymentGatewayErrorModal() {
  return { type: EMPLOYEE_STAFF_HIDE_PAYMENT_GATEWAY_ERROR_MODAL, payload: {} };
}

export function showDeactivateEmployeeErrorMessage(message) {
  return {
    type: EMPLOYEE_STAFF_DEACTIVATE_SET_ERROR_MESSAGE,
    payload: { message },
  };
}
